import script from "./HeaderUserDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderUserDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderUserDropdown.vue?vue&type=style&index=0&id=77d477be&scoped=true&lang=css"
import "./HeaderUserDropdown.vue?vue&type=style&index=1&id=77d477be&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d477be"]])

export default __exports__